module.exports = __webpack_public_path__ + "static/media/fsb.a583b101.png";